// src/components/headers/AgencyHeader.js

import Header from '../base/Header';

/**
 * AgencyHeader:
 * - agencyId: URL や親コンポーネントから渡される現在の代理店 ID
 * - onMenuToggle: メニュー開閉用ハンドラ
 * 
 * 管理者兼代理店ユーザ、または未登録の代理店ユーザのみ
 * 「代理店検索」メニューを表示します。
 */
const AgencyHeader = ({ onMenuToggle, agencyId }) => {
  // localStorage に保存されたユーザ種別とユーザ情報を取得
  const userType = localStorage.getItem('userType');
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const storedAgencyId = userInfo.agency_id;

  // 「代理店検索」へのアクセス権判定
  // - 管理者かつ agency_id がある （管理者兼代理店）
  // - 代理店ユーザかつ agency_id が null （未登録の代理店）
  const canSearch = (
    userType === 'admin' && !!storedAgencyId
  ) || (
    userType === 'agency' && !storedAgencyId
  );

  // メニューアイテムを動的に組み立て
  const menuItems = [];

  if (canSearch) {
    // 代理店検索が許可されるユーザのみ追加
    menuItems.push({
      label: '代理店検索',
      path: '/agency/search'
    });
  }

  if (storedAgencyId) {
    // 代理店 ID が存在する場合のみ「代理店詳細」を追加
    menuItems.push({
      label: '代理店詳細',
      path: `/agency/detail/${storedAgencyId}`
    });
  }

  // 常に「アカウント設定」は表示
  menuItems.push({
    label: 'アカウント設定',
    path: '/agency/account/edit'
  });

  return (
    <Header
      onMenuToggle={onMenuToggle}
      menuItems={menuItems}
    />
  );
};

export default AgencyHeader;
